module.exports = __webpack_public_path__ + "img/squidward_tentacles.bdca6000.jpg";